import { useSelector } from "react-redux";
import { THEME_MODES } from "helpers/themeMode";

/**
 * Hook centralizado para obtener el modo de tema actual.
 * Elimina la duplicación del patrón useSelector + isDark en múltiples componentes.
 * @returns {{ themeMode: string, isDark: boolean }}
 */
export const useThemeMode = () => {
  const themeMode = useSelector(
    (state) => state.config.themeMode || THEME_MODES.LIGHT
  );
  const isDark = themeMode === THEME_MODES.DARK;
  return { themeMode, isDark };
};
